<template>
    <div id="all" class="all">
        <van-row class="title">
            <van-col span="4"></van-col>
            <van-col span="4"><van-button @click="prev()" class="top-button" size="small" round icon="arrow-left"
                    type="info" color="#dbdbdb" plain></van-button></van-col>
            <van-col span="8">{{ title }}</van-col>
            <van-col span="4"> <van-button @click="next()" class="top-button" size="small" round icon="arrow"
                    type="info" color="#dbdbdb" plain></van-button></van-col>
            <van-col span="2">
                <van-icon @click="openForm()" class="icon" name="plus" size="1.4rem" />
            </van-col>
            <van-col span="2">

                <van-icon @click="show = true" class="icon" name="filter-o" size="1.4rem" />
            </van-col>
        </van-row>
        <div id="myElement">
            <div id="calendar" style=" height: calc(100vh - 40px - 50px);overflow:auto;"></div>
        </div>
        <van-popup v-model="show" position="right" round closeable close-icon="close"
            :style="{ height: '100%', width: '90%' }">
            <div style="display:flex;flex-direction: column;width:100%;height:100vh">
                <div class="popup-h4">
                    <van-icon name="filter-o" size="1.3rem" />
                    <span class="popup-icon">日历信息</span>
                </div>
                <van-divider />
                <div class="bggrow">
                    <van-collapse class="popup-collasp" v-model="activeNames" accordion>
                        <van-collapse-item title="值班类型" name="1">
                            <van-cell :title="item.summary" v-for="(item, index) in templelist" :key="index">
                                <template>
                                    <van-switch v-model="item.checked" @change="getlistBytemple"
                                        :active-color="item.color" size="24" />
                                </template>
                            </van-cell>
                        </van-collapse-item>
                    </van-collapse>

                    <van-field readonly clickable label="值班人员" :value="value" placeholder="选择人员"
                        @click="showPicker = true" />
                    <van-popup v-model="showPicker" round position="bottom">
                        <van-field v-model="search" label="查询" placeholder="请输入您想要查找的用户" @input="searchFun" />
                        <van-picker show-toolbar :columns="searchcolumns" @cancel="onCancel" @confirm="onConfirm" />
                    </van-popup>

                </div>
            </div>
        </van-popup>


        <van-popup round v-model="popup_show" position="bottom" :style="{ height: '80%' }">
            <FormView ref="formview" @close="closeform"></FormView>
        </van-popup>
    </div>

</template>

<script>
/* eslint-disable */
import FormView from './Compents/FormView.vue';
import Calendar from '@toast-ui/calendar';
import { getScheduling, getTempleList, GetRoleUser } from "@/api/Scheduling/Scheduling";
import moment from "moment";
import Hammer from 'hammerjs'

export default {
    components: {
        FormView
    },
    data() {
        return {
            title: null,
            list: [],
            show: false,
            activeNames: '1',
            templelist: [],
            date: new Date(),
            calendar: null,
            userList: [],
            columns: [],
            searchcolumns: [],
            search: '',
            showPicker: false,
            value: '',
            templefilter: [],

            popup_show: false,


        }
    },
    methods: {
        async closeform() {
            this.popup_show = false;

            await this.changemonth({
                date: this.date,
            });
        },
        openForm() {
            this.popup_show = true;
            this.$nextTick(() => {
                console.log(this.$refs["formview"], '123');
                this.$refs["formview"].dialogOpen(null, 5);
            })
        },
        searchFun: function () {
            this.searchcolumns = this.columns.filter(t => t.indexOf(this.search) > -1);
        },
        onCancel: async function () {
            this.value = '';
            await this.changemonth({
                date: this.date,
            });
            this.showPicker = false;
            this.show = false;
        },
        prev: async function () {
            this.calendar.prev();
            this.date = this.calendar.getDate().d.d;
            console.log(this.date.date, 'date');

            await this.changemonth({
                date: this.date,
            });
            this.title = this.date.getFullYear() + "年" + parseInt(this.date.getMonth() + 1) + "月";
            console.log(this.date, 'date');
        },
        next: async function () {
            this.calendar.next();
            this.date = this.calendar.getDate().d.d;
            await this.changemonth({
                date: this.date,
            });
            this.title = this.date.getFullYear() + "年" + parseInt(this.date.getMonth() + 1) + "月";

            console.log(this.date, 'date');
        },
        /**
         * 获得列表通过模板
         */
        getlistBytemple: async function () {
            const date = new Date();
            this.templefilter = this.templelist.filter(t => t.checked == true).map(t => t.id)
            await this.changemonth({
                date: date,
            })
        },
        getTempleList: async function () {
            let res = await getTempleList(5);
            console.log(res, 'res');
            this.templelist = res.items.map(t => {
                t.checked = true;
                return t;
            });
        },
        getList: async function () {
            const date = new Date();
            await this.changemonth({
                date: date,
            });
        },
        getUserList: async function () {
            let arr = this.list.map(t => t.userName);
            this.columns = arr.filter((item, index) => arr.indexOf(item) === index);
            this.searchcolumns = this.columns;
        },
        /**
         * 修改月会显示
         * @param {*} date
         */
        async changemonth(date) {
            console.log(date.date, 'datechange', moment(date.date).date(1).add(-1, "W").format("YYYY-MM-DD 00:00:00"));
            var res = await getScheduling({
                BeginTime: moment(date.date).date(1).add(-1, "W").format("YYYY-MM-DD 00:00:00"),
                EndTime: moment(date.date).date(1).add(1, "M").add(1, "W").format("YYYY-MM-DD 00:00:00"),
                templelist: this.templefilter,
                username: this.value,
                createType: 5
            });
            this.list = res;

            this.calendar.clear(true);
            const arr = this.list.map(item => {
                const str = item.description ? item.description == "null" ? '' : '<div class="summary_img">' + item.description + '</div>' : '';
                return {
                    id: item.id,
                    calendarId: '1',
                    title: item.userName + "&nbsp;&ensp;&emsp;&nbsp;" + item.summary,
                    attendees: null,
                    category: 'allday',
                    start: moment(item.beginTime).format("YYYY-MM-DDTHH:mm:ss+08:00"),
                    end: moment(item.endTime).format("YYYY-MM-DDTHH:mm:ss+08:00"),
                    isAllDay: true,
                    location: item.summary,
                    color: 'white',
                    backgroundColor: item.color,
                    state: null,
                    isReadOnly: true,
                    // body:str,
                    customStyle: { 'fontSize': '10px', 'marginBottom': '5px' }//height:14px !important;line-height:14px !important
                }
            })
            this.calendar.createEvents(arr);
            this.calendar.render();

        },
        toWrite() {
            this.$router.push('calendar');
        },
        /**
         * 选择完人后的事情
         */
        async onConfirm(value) {
            this.value = value;


            await this.changemonth({
                date: this.date,
            });
            this.showPicker = false;
            this.show = false;
            console.log(this.value, 'value');
        }
    },
    mounted: async function () {

        await this.$store.dispatch("app/setActive", 0);
        var element = document.getElementById("calendar");
        var hammer = new Hammer(element);
        const that = this;
        hammer.on('swipeleft swiperight ', function (ev) {
            switch (ev.type) {
                case "swipeleft":
                    that.next();
                    break;
                case "swiperight":
                    that.prev();
                    break;
            }
        })

        this.date = new Date();
        this.title = this.date.getFullYear() + "年" + parseInt(this.date.getMonth() + 1) + "月";

        var calendar = new Calendar("#calendar", {
            defaultView: 'month',// Initial view type. Available values are: 'day', 'week', 'month'.
            isReadOnly: true,  // Whether the calendar is read-only.
            useDetailPopup: false,// Whether to use the default detail popup when clicking events
            // calendars: MOCK_CALENDARS,
            month: {
                dayNames: ['日', '一', '二', '三', '四', '五', '六'],

                isAlways6Weeks: false,
                startDayOfWeek: 0,
            },
            template: {
                /**
                 * 打开更多后的标题
                 * @param {*} date 
                 * @param {*} dayname 
                 */
                // monthMoreTitleDate: function(date, dayname) {
                //     var day = date.split('.')[2];
                //     return '<span class="tui-full-calendar-month-more-title-day">' + day + '</span> <span class="tui-full-calendar-month-more-title-day-label">' + dayname + '</span>';
                // },
                // monthGridHeader: function(dayModel) {
                //     var date = parseInt(dayModel.date.split('-')[2], 10);
                //     var classNames = ['tui-full-calendar-weekday-grid-date '];

                //     if (dayModel.isToday) {
                //         classNames.push('tui-full-calendar-weekday-grid-date-decorator');
                //     }

                //     return '<span class="' + classNames.join(' ') + '">' + date + '</span>';
                // },
                /**
                 * 更多的样式
                 * @param {*} hiddenSchedules 
                 */
                monthGridHeaderExceed: function (hiddenSchedules) {
                    return '<span class="weekday-grid-more-schedules">+' + hiddenSchedules + '</span>';
                },
                monthMoreTitleDate: function (moreTitleDate) {
                    console.log(moreTitleDate, 'morTitleDate');
                    return '<span class="tui-full-calendar-month-more-title-day">' + moreTitleDate.date + '</span>';
                },
            },
        })
        this.calendar = calendar;
        await this.getList();
        this.getUserList();
        calendar.on('clickDayname', function (event) {
            console.log(event, 'event');
            if (calendar.getViewName() === 'week') {
                calendar.setDate(new Date(event.date));
                calendar.changeView('day', true);
            }
        });

        calendar.on('clickEvent', ({ event }) => {
            console.log(event); // EventObject

            this.popup_show = true;



            this.$nextTick(() => {
                console.log(this.$refs.formview, this.$refs["formview"], '111111111111');
                this.$refs["formview"].dialogOpen(event.id, 5);

                const seeMoreBtn = document.querySelector('.toastui-calendar-see-more');

                // 若元素存在则删除
                if (seeMoreBtn) {
                    seeMoreBtn.remove(); // 直接从DOM中移除
                }
            })

        });


        // calendar.on('_onClick',function(event){
        //     console.log(event);
        // })
        await this.getTempleList();

        // this.$nex
        //console.log(calendar,document.querySelector(".tui-full-calendar-weekday-grid-date-decorator").parentElement());
    }
}
</script>

<style lang="scss">
.top-button {
    margin: 0 10px !important;
}

.summary_img {
    display: flex;

    &:before {
        content: '';
        display: block;
        // 定义元素位置
        margin-top: 5px;
        margin-right: 7px;
        // 定义元素宽高
        width: 13px;
        height: 13px;
        // background-image无法引用本地资源，故需要用网络地址
        background-image: url('../../assets/job.png');
        background-size: 100% 100%;
    }
}

.title {
    text-align: center;
    line-height: 44px;
    height: 44px;
    font-weight: 500;
    font-size: 14px;

    .icon {
        vertical-align: middle;
    }
}

.tui-full-calendar-near-month-day {
    border: none !important;
}

.tui-full-calendar-weekday-border {
    border: none !important;
}

.tui-full-calendar-month-dayname {
    box-shadow: 0 2px 10px rgba(125, 126, 128, 0.16);
}

.tui-full-calendar-month-dayname {
    border-top: none !important;
}

.tui-full-calendar-month-dayname-item {
    font-size: 10px;
    font-weight: 400;
    font-family: Avenir, Helvetica, Arial, sans-serif;
}

.lite {
    font-size: 12px;
}

.tui-full-calendar-today {
    margin-left: 0 !important;
}

.tui-full-calendar-month-week-item .tui-full-calendar-today .tui-full-calendar-weekday-grid-date-decorator {
    margin-left: 0 !important;
}

// .weekday-grid-more-schedules {
//     background-color: #409eff;
//     font-size: 10px;
//     height: 18px;
//     line-height: 18px;
//     text-align: center;
//     vertical-align: 3px;
//     white-space: nowrap;
//     color: white;
//     border: 1px solid #409eff;
// }

// .toastui-calendar-template-monthGridHeader:has(.tui-full-calendar-weekday-grid-date-decorator){
//     background: rgb(255, 64, 64) !important;
//     color:white !important;
// }

.tui-full-calendar-weekday-grid-date-decorator {
    color: rgb(255, 39, 39);
    font-weight: bold;
    font-size: 19px;
    /* margin-top: -17.2px; */
    line-height: 1.5;
}



// .toastui-calendar-grid-cell-date:has(.tui-full-calendar-weekday-grid-date-decorator)
// .toastui-calendar-grid-cell-date:has(.tui-full-calendar-weekday-grid-date-decorator){
//     background-color: red!important;
// }
// .tui-full-calendar-weekday-grid-date  .tui-full-calendar-weekday-grid-date-decorator{
//     color:red;
// }
// .tui-full-calendar-today .weekday-grid-more-schedules {
//     background-color: white;
//     border: 1px solid #409eff;
//     color: #409eff;
// }

.tui-full-calendar-weekday-grid {
    overflow-y: inherit !important;
}

.Position-button {
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    width: 3rem;
    height: 3rem;
    overflow: hidden;
    border-radius: 100%;
    background: #409eff;
    vertical-align: middle;
    text-align: center;
    display: table-cell;

    >img {
        margin: 0.8rem auto;
        width: 1.5rem;
    }
}

.all {
    display: flex;
    overflow: none !important;
    flex-direction: column;
    height: 100%;

    #myElement {
        //flex:1;
        height: 1000px;
    }
}

.van-collapse-item__content {
    padding: 0 16px !important;
}

.tui-full-calendar-weekday-schedule {
    border: none !important;
    margin-left: 4px !important;
}

.van-cell {
    // line-height: 24px !important;
    // padding: 10px 16px !important;
}

/* 
*{
    font-size:23px !important;
    .tui-full-calendar-weekday-schedule-title{
        height:22px !important;
       line-height:14px
    }
} */
.toastui-calendar-month .toastui-calendar-day-names {
    box-shadow: 0 2px 10px hsl(220deg 1% 50% / 16%) !important;
}

.tui-full-calendar-weekday-schedule-title {
    text-overflow: unset !important;
}

.toastui-calendar-daygrid-cell+.toastui-calendar-daygrid-cell {
    border: none !important;
}

.toastui-calendar-weekday-grid {
    border: none !important;
}

.toastui-calendar-weekday-event {
    margin: 0 5px !important;
    border: none !important;
}
</style>
<style lang="scss" scoped>
.popup-h4 {
    margin: auto;
    padding-left: 1rem;
    margin: 1rem auto;
    font-size: 14px;
    width: -webkit-fill-available;
    font-weight: bold;
}

.popup-icon {
    vertical-align: 2px;
    margin-left: 0.5rem;
}

.bggrow {
    background: #f7f8fa;
    flex: 1;
}

.van-divider {
    margin: auto;
}

.popup-collasp {
    margin-top: 1rem;
}

::v-deep .toastui-calendar-grid-cell-more-events {
    position: absolute;
}

::v-deep .weekday-grid-more-schedules {
    font-size: 13px;
}

::v-deep .toastui-calendar-grid-cell-date {
    text-align: right;
    width: 21px;
}

::v-deep .toastui-calendar-weekday-grid-date-decorator {
    width: 24px !important;
    height: 24px !important;
    background-color: #ed1631 !important;
}

::v-deep .toastui-calendar-see-more-header {
    margin-bottom: 5px !important;
    height: auto !important;
    padding: 5px 17px 0px !important;
}

::v-deep .toastui-calendar-month-more-list {
    height: calc(100% - 10px) !important;
}


* {
    touch-action: manipulation;
    /* 禁用双击缩放，改善点击体验 */
}
</style>